// extracted by mini-css-extract-plugin
module.exports = {"headerCardWithShadow":"Header_headerCardWithShadow__2NLOx","viewGroup":"Header_viewGroup__1BHrF","drawer":"Header_drawer__2lMX7"};